"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleModalContext = exports.Modal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const alert_dialog_1 = require("@reach/alert-dialog");
require("@reach/dialog/styles.css");
const react_1 = require("react");
const tools_1 = require("../../tools");
const ButtonGroup_1 = require("../ButtonGroup");
const Modal = function Modal({ onDismiss, children, leastDestructiveRef, isOpen = true, size, }) {
    const value = react_1.useMemo(() => ({ onDismiss: onDismiss !== null && onDismiss !== void 0 ? onDismiss : (() => { }) }), [onDismiss]);
    const buttonGroupContextValue = react_1.useMemo(() => ({ inGroup: false }), []);
    return (jsx_runtime_1.jsx(ButtonGroup_1.ButtonGroupContext.Provider, Object.assign({ value: buttonGroupContextValue }, { children: jsx_runtime_1.jsx(exports.SingleModalContext.Provider, Object.assign({ value: value }, { children: jsx_runtime_1.jsx(StyledAlertDialogOverlay, Object.assign({ isOpen: isOpen, onDismiss: onDismiss, leastDestructiveRef: leastDestructiveRef }, { children: jsx_runtime_1.jsx(StyledAlertDialogContent, Object.assign({ size: size }, { children: children }), void 0) }), void 0) }), void 0) }), void 0));
};
exports.Modal = Modal;
const StyledAlertDialogOverlay = tools_1.styled(alert_dialog_1.AlertDialogOverlay) `
  padding: 2rem;
  background-color: rgba(0, 0, 0, 0.4);
`;
const StyledAlertDialogContent = tools_1.styled(alert_dialog_1.AlertDialogContent) `
  &[data-reach-dialog-content],
  & [data-reach-dialog-content] {
    width: 100%;
    max-width: ${({ size }) => maxWidthForSize(size)};
    margin: ${({ size }) => marginForSize(size)};
  }
`;
function maxWidthForSize(size = 'md') {
    switch (size) {
        case 'xl':
            return 'none';
        case 'lg':
            return '1200px';
        case 'md':
            return '900px';
        case 'sm':
            return '500px';
        case 'xs':
            return '300px';
        default:
            return 'none';
    }
}
function marginForSize(size = 'md') {
    switch (size) {
        case 'xl':
            return '0 auto';
        default:
            return '10vh auto';
    }
}
exports.SingleModalContext = react_1.createContext({ onDismiss: () => { } });
//# sourceMappingURL=index.js.map